module.exports = __webpack_public_path__ + "static/media/empty-box.41b7d990.png";